import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Ciudad } from "@/shared/types/ciudad";

export interface CiudadEditRequest {
    nombre: string;
    codigo: string;
    departamentoId: string;
}

export async function editCiudad(id: string, request: CiudadEditRequest): Promise<Ciudad> {
    await sleep(1000);
    const response = await api.put("ciudades/" + id, request);
    return response.data;
}

export function useEditCiudadMutation(id: string, mutationConfig: MutationConfig<Ciudad, CiudadEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: CiudadEditRequest) => await editCiudad(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["ciudades"] });
        },
    });
}

export interface EditCiudadMutationProps {
    id: string;
    mutationConfig?: MutationConfig<Ciudad, CiudadEditRequest>;
    children?: (mutationResult: MutationResult<Ciudad, CiudadEditRequest>) => ReactNode;
}

export function EditCiudadMutation({
    id,
    children,
    mutationConfig,
}: EditCiudadMutationProps) {
    const mutationResult = useEditCiudadMutation(id, mutationConfig);
    return children && children(mutationResult);
}